import queryString from 'query-string';
import { MouseEvent, useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { showModal } from 'modules/main/store/ducks/modal.actions';
import { useMainDispatch } from 'modules/main/store/hooks/useMainDispatch';
import { trackClicked } from 'utils/analytics/track/trackClicked';

export function useLogin() {
  const dispatch = useMainDispatch();
  const location = useLocation();
  const redirectTo = location ? `${location.pathname}${location.search}` : '';
  const redirectParam = queryString.stringify({
    to: redirectTo,
  });

  const onClickLogin = useCallback(
    (e: MouseEvent<HTMLAnchorElement>) => {
      e.preventDefault();
      trackClicked('Log In Header');
      dispatch(
        showModal('LOGIN', {
          redirectTo,
          manualLogin: true,
        }),
      );
    },
    [redirectTo, dispatch],
  );

  const loginLink = `/login?${redirectParam}`;

  return { onClickLogin, loginLink };
}
